import { FC } from 'react';
import { AText, Box } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';

import styles from './index.module.css';

interface AlertBoxProps {
  label: string;
}

export const AlertBox: FC<AlertBoxProps> = ({ label }) => {
  const { t } = useI18n();
  return (
    <Box className={styles.wrapper}>
      <AText breed="B" size="s" color="txt_color_5">
        {t(label)}
      </AText>
    </Box>
  );
};
